import {
  Component} from '@angular/core';
import gsap from 'gsap';


import { Subject } from 'rxjs';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
  CalendarEvent,
} from 'angular-calendar';
import { PortService } from 'src/app/core-services/port.service';
import { portcalvm } from 'src/app/models/portcalpostmodel';
import { Port } from 'src/app/models/Port';
import { Validators, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { DataParam } from 'src/app/Enum/Enum';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

interface EventGroupMeta {
  type: string;
}


@Component({
  templateUrl: './portcalendarsplash.component.html',
  styleUrls: ['./portcalendarsplash.component.scss'],
  providers: [DatePipe],
})
export class PortcalendarSplashComponent {
  viewDate: Date = new Date();
  month: number = -1;
  transit = new portcalvm();
  voyagelist: any;
  vesselslist: any;
  vesselsListData: any;
  voyageListData: any;
  submitted: boolean = false;
  BremerPortId: number = 0;
  shippinglineslist: any;
  shippinglineslistData: any;
  portsData: Port[] = [];
  activeDayIsOpen = false;
  isShowFooter: boolean = false;
  refresh: Subject<any> = new Subject();
  events: CalendarEvent[] = [];
  ismonth = true;
  isweek = false;
  isday = false;

  portCalform = this.fb.group({
    PortId: ["", Validators.required],
    vesselsId: ["", Validators.required],
    voyageId: ["", Validators.required],
    shippinglineId: ["", Validators.required]
  });

  constructor(
    private modal: NgbModal,
    private router: Router,
    private portService: PortService,
    private fb: FormBuilder,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer) {
  }

  groupedSimilarEvents: CalendarEvent[] = [];
  ngOnInit() {
    window.document.title = "ENL Solutions"
    this.getshippingline();
    this.getPortCalenderDropdowns();

    // Set values on load
    /* this.portCalform.patchValue({
      PortId: { id: 6057, portName: "Bremerhaven", portCode: "DE BRV", countryCode: "DE"}
    }) */
  }
  ngAfterViewInit() {
    gsap.to('.content', { y: 0, opacity: 1, duration: 0.85 });
  }

  refreshView(): void {
    this.refresh.next(null);
  }


  getshippingline() {
    this.portService.GetShippingLines().subscribe((response: any) => {
      if (response) {
        this.shippinglineslist = response.content;
      } else {
        this.shippinglineslist = null;
      }
    });
  }

  getVesselsbyShipsId(event) {
     this.portCalform.controls.vesselsId.setValue('');

    if (event) {
      var shipsId = event.value.shippingLineId > 0 ? event.value.shippingLineId : 0;
      if (shipsId > 0) {
        this.vesselslist = this.vesselsListData.filter(x => x.shippingLineid == shipsId);
        this.voyagelist = this.voyageListData;
        // this.portCalform.controls.voyageId.setValue('');
      }
      else {
        this.vesselslist = this.vesselsListData;
        this.voyagelist = this.voyageListData;
      }
    }
    else {
      this.vesselslist = this.vesselsListData;
      this.voyagelist = this.voyageListData;
    }
  }

  getVoyagebyVesselsId(event) {
    // this.portCalform.controls.voyageId.setValue('');

    if (event != null && event.value != null) {
      var vesselsId = event.value.id > 0 ? event.value.id : 0;
      if (vesselsId > 0) {
        this.voyagelist = this.voyageListData.filter(x => x.vesselsId == vesselsId);
      }
      else {
        this.voyagelist = this.voyageListData;
      }
    }
    else {
      this.voyagelist = this.voyageListData;
    }
  }


  searchPorts(event) {
    console.log(event);
    if (event != null && event.query != null && event.query != "") {
      if (event.query.length > 2) {
        var data = {
          PortName: event.query
        };
        this.portService.GetPortDataByName(data).subscribe((response: any) => {
          if (response != null && response.content != null) {
            this.portsData = response.content;
            console.log(this.portsData);
          } else {
            this.portsData = [];
          }
        });
      }
      else {
        this.portsData = [];
      }
    } else {
      //this.getPortData();

    }
  }

  getPortCalenderDropdowns() {
    this.portService.GetvoyageandvesselsList().subscribe((response: any) => {
      if (response) {
        this.voyagelist = response.content.voyages;
        this.vesselslist = response.content.vessels;
        this.vesselsListData = response.content.vessels;
        this.voyageListData = response.content.voyages;
      } else {
        this.shippinglineslist = null;
      }
    });
  }

  onCalenderSearch() {
    this.submitted = true;

    const data = this.portCalform.value;
    const shouldSearch: boolean | string = data.PortId || data.vesselsId || data.voyageId || data.shippinglineId;

    localStorage.setItem(DataParam.PortcalendarSearch, JSON.stringify(data));

    if (shouldSearch) {
      this.router.navigate(['portcalendar']);
    }
    else {
      this.toastr.error("Please enter detail", "Error!");
    }
  }


  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}






